import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=12f26da4&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=12f26da4&prod&lang=less&scoped=true"
import style1 from "./footer.vue?vue&type=style&index=1&id=12f26da4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f26da4",
  null
  
)

export default component.exports